import { createSlice, createAsyncThunk, current } from "@reduxjs/toolkit";
import axios from "axios";

export const getTermsAndConditions = createAsyncThunk(
    "termsAndConditions/getClientTermsAndConditions",
    async (params, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/client/termsandconditions`);
            console.log(response);
            if(response.data.sucess){
                return response.data.data;
            }else{
                return null;
            }
           
        }
        catch (err) {
            return rejectWithValue("Failed to get all termsAndConditions!");
        }
    })

const termsAndConditionsSlice = createSlice({
    name: "termsAndConditions",
    initialState: {
        termsAndConditions:null,
    },
    extraReducers: builder => {
        builder
          .addCase(getTermsAndConditions.pending, (state, action) => {
            state.status = 'loading'
          })
          .addCase(getTermsAndConditions.fulfilled, (state, action) => {
            state.termsAndConditions=action.payload
            state.status = 'idle'
          }) .addCase(getTermsAndConditions.rejected, (state, action) => {
            // state.termsAndConditions=action.payload
            state.status = 'failed'
          })
      }
    
})
export default termsAndConditionsSlice;

// extraReducers: {
//     [getTermsAndConditions.fulfilled]: (state, { payload }) => {
//         state.termsAndConditions = payload;
//     },
// }